import { create } from 'zustand'

type SlowConnectionBannerState = {
  isVisible: boolean
  setVisible: (visible: boolean) => void
}

export const useSlowConnectionBannerStore = create<SlowConnectionBannerState>(
  set => ({
    isVisible: false,
    setVisible: (visible) => set({ isVisible: visible }),
  }),
)
